import React, { useState, useEffect, useRef } from 'react'
import ExamReportCardPDF from './examReportCardPDF.js';
import ExamReportCardPDFAndroid from "./examReportCardPDFAndroid.js";
import { getLogoSvc, getPrinciSignSvc, getExamReportSvc } from './examReportSvc.js';
// , getDocDtlsSvc
import { toast, ToastContainer } from 'react-toastify';
import lstModules from 'common/json/lstModules.json';
import NoImage from "images/no-image.png";





const ExamReportSliderAndroid = (props) => {

  const { heading, sectionId, examId, exam, syllabusId, flgValidated } = props;

  const [reportCard, setReportCard] = useState({});
  const [logoUrl, setLogoUrl] = useState('');
  // const [imageUrl, setImageUrl] = useState("");
  const [principalSignUrl, setPrincipalSignUrl] = useState("");
  const [teacherSignUrl, setTeacherSignUrl] = useState("");
  // const [flgTeacherSignUpdated, setFlgTeaherSignUpdated] = useState(false);


  useEffect(() => {
    // console.log("ExamReportSliderAndroid Called heading ", props.heading, ", sectionId ", props.sectionId);
    // console.log("teacherSignUrl", props.teacherSignUrl);

    setTeacherSignUrl(props.teacherSignUrl);
    getPrinciSignSvc(cbPrinciSign);
    getLogoSvc(cbLogoResponse);
    getTermReport(syllabusId);
    return () => {
      setTeacherSignUrl("");
      setReportCard({});
    };
  }, [props.sectionId, examId, exam, props.teacherSignUrl, syllabusId]);

  function cbPrinciSign(imageUrl) {
    setPrincipalSignUrl(imageUrl);
  }
  function cbLogoResponse(imageUrl) {
    // console.log("cbLogoResponse called, imageUrl", imageUrl);
    setLogoUrl(imageUrl)
  }

  const getTermReport = (pSyllabusId) => {
    props.showLoader();
    getExamReportSvc(examId, sectionId, pSyllabusId, TermReportResponse);
  }

  const TermReportResponse = async (data) => {
    // console.log("TermReportResponse called, data", data);
    let obj = data;
    if (obj.status === 'Success') {
      setReportCard(obj.lstReportCardObj);
    } else {
      setReportCard({});
      if (obj.message === 'You are not logged in' || obj.message === 'Your Session is expired, login again') {
        setTimeout(() => {
          window.location.href = "/";
        }, 2000);
        return false;
      } else {
        toast.error(obj.message);
      }
    }

    props.hideLoader();
  };


  const closeSlider = async() => {
  await setReportCard({});
    props.removeClassFromBody();
  }



  return (
    <div >
      {reportCard && reportCard.lstStudent && reportCard.lstStudent.length ?
        <ExamReportCardPDFAndroid
          key={reportCard}
          logoUrl={logoUrl}
          exam={exam}
          // lstReportCard={lstReportCard}
          reportCard={reportCard}
          principalSignUrl={principalSignUrl}
          teacherSignUrl={teacherSignUrl}
          flgValidated={flgValidated}
          showLoader={props.showLoader}
          hideLoader={props.hideLoader}
          closePdf={closeSlider}
        />
        : null
      }
    </div>
  );
}

export default ExamReportSliderAndroid;